import { TopWriterByViewTable } from './TopWriterByViewTable'
import { withTopWriterByViewTable } from './withTopWriterByViewTable'

const Connected = withTopWriterByViewTable(TopWriterByViewTable)

export { Connected as TopWriterByViewTable }
